export default __webpack_public_path__ + "media/images/pumpkins-fun-card-title-e11abab50d3bb871430a8b5a6d9ffdaf.svg";